
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.97 2.353H6.03a3.68 3.68 0 00-3.677 3.676v27.942a3.68 3.68 0 003.676 3.676h27.942a3.68 3.68 0 003.676-3.676V6.029a3.68 3.68 0 00-3.676-3.676zm.736 3.676v12.5H21.47V5.294h12.5c.406 0 .735.33.735.735zM6.029 5.294h12.5V18.53H5.295V6.03c0-.404.33-.735.735-.735zm-.735 28.677v-12.5H18.53v13.235H6.03a.736.736 0 01-.736-.735zm28.677.735h-12.5V21.47h13.235v12.5c0 .405-.33.736-.735.736z","fill":"currentColor"}})])
          )
        }
      }
    